import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/registration/lock-icon.svg'
import _imports_1 from '../../assets/registration/info-icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-76207ac8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "change-password-container" }
const _hoisted_2 = { class: "form-container" }
const _hoisted_3 = { class: "password-label-section" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "current password" }, "Current password", -1))
const _hoisted_5 = {
  key: 0,
  class: "text-danger",
  "data-test": "incorrect-password"
}
const _hoisted_6 = {
  key: 1,
  class: "text-danger",
  "data-test": "current-password-required"
}
const _hoisted_7 = { class: "input-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "placeholder-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "password lock icon",
    src: _imports_0
  })
], -1))
const _hoisted_9 = { class: "password-label-section" }
const _hoisted_10 = { class: "new-password-label" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "new-password" }, "New password", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "password-icon",
  alt: "password rules information",
  class: "info-icon",
  src: _imports_1,
  tabindex: "0"
}, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "text-danger",
  "data-test": "new-password-required"
}
const _hoisted_14 = {
  key: 1,
  class: "text-danger",
  "data-test": "new-password-min"
}
const _hoisted_15 = {
  key: 2,
  class: "text-danger",
  "data-test": "invalid-password"
}
const _hoisted_16 = { class: "input-container" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "placeholder-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "password lock icon",
    src: _imports_0
  })
], -1))
const _hoisted_18 = { class: "password-label-section" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "confirm password" }, "Confirm new password", -1))
const _hoisted_20 = {
  key: 0,
  class: "text-danger",
  "data-test": "confirm-password-required"
}
const _hoisted_21 = {
  key: 1,
  class: "text-danger",
  "data-test": "not-same-as"
}
const _hoisted_22 = { class: "input-container" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "placeholder-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "password lock icon",
    src: _imports_0
  })
], -1))
const _hoisted_24 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_25 = {
  key: 1,
  style: {"display":"block"},
  class: "text-danger"
}
const _hoisted_26 = { class: "password-controls" }

import { computed, reactive, ref } from "vue";
import axios, { AxiosError, AxiosResponse } from "axios";
import { debug as d } from "debug";
import { useVuelidate } from "@vuelidate/core";
import { minLength, required, sameAs } from "@vuelidate/validators";
import { Tooltip } from "uiv";
import { ChangePasswordApiModel } from "../../api-models";

interface ErrorData {
  incorrectPassword: string | null;
  otherErrorData: string | null;
  serverErrorOccured: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'change-password',
  emits: ["toggle-change-password", "toggle-success-message"],
  setup(__props, { emit: __emit }) {

const debug = d("cs.ChangePassword");

const emit = __emit;

function isPasswordValid(value: string): boolean {
  const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/;
  const passwordArray = value.match(passwordRegex);
  if (passwordArray) {
    return passwordArray?.length > 0;
  }
  return false;
}

const currentPassword = ref("");
const newPassword = ref("");
const confirmPassword = ref("");

const submitStatus = ref("");
const attemptedToSubmit = ref(false);
const badRequest = ref(false);

const errorData = ref({
  incorrectPassword: null,
  otherErrorData: "",
  serverErrorOccured: false,
} as ErrorData);

const rules = {
  currentPassword: {
    required,
    minLength: minLength(6),
  },
  newPassword: {
    required,
    minLength: minLength(8),
    isPasswordValid,
  },
  confirmPassword: {
    required,
    sameAsPassword: sameAs(newPassword),
  },
};

const state = reactive({
  currentPassword,
  newPassword,
  confirmPassword,
});

const v$ = useVuelidate(rules, state, { $autoDirty: true });

function toggleChangePassword(): void {
  emit("toggle-change-password");
}

const canSubmit = computed(() => {
  return (
    !v$.value.currentPassword.required.$invalid &&
    !v$.value.newPassword.required.$invalid &&
    !v$.value.confirmPassword.required.$invalid
  );
});

function handleSubmit(): void {
  if (canSubmit.value) {
    const newPasswordModel: ChangePasswordApiModel = {
      currentPassword: currentPassword.value,
      newPassword: newPassword.value,
      confirmPassword: confirmPassword.value,
    };
    axios
      .post("/api/myaccount/changepassword", newPasswordModel)
      .then((resp: AxiosResponse) => {
        if (resp.status === 200 && resp.data) {
          if (resp.data === "Incorrect password.") {
            errorData.value.incorrectPassword = "Your current password is incorrect";
            return;
          }
          errorData.value = resp.data;
          return;
        }
        switch (resp.status) {
          case 200:
            emit("toggle-success-message", {
              isDetailsUpdated: true,
              detailChanged: "password",
            });
            toggleChangePassword();
            break;
          case 400:
            badRequest.value = true;
            break;
          case 500:
            errorData.value.serverErrorOccured = true;
            break;
          default:
            break;
        }
      })
      .catch((e: AxiosError) => {
        debug(e);
        if ((e.response?.request.responseURL as string).endsWith("500")) {
          errorData.value.serverErrorOccured = true;
        }
      });
  }
}

async function handleSubmitNewPassword(): Promise<void> {
  const isFormValid = await v$.value.$validate();
  attemptedToSubmit.value = true;
  if (!isFormValid) {
    submitStatus.value = "Error";
  } else {
    submitStatus.value = "OK";
    handleSubmit();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "change-password-form",
        method: "post",
        onSubmit: _withModifiers(handleSubmitNewPassword, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (errorData.value.incorrectPassword)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(errorData.value.incorrectPassword), 1))
            : _createCommentVNode("", true),
          (_unref(v$).currentPassword.required.$invalid && submitStatus.value === 'Error')
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "You must enter your current password"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              id: "current password",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPassword).value = $event)),
              class: "password-input",
              name: "current password",
              type: "password",
              onBlur: _cache[1] || (_cache[1] = ($event: any) => (_unref(v$).currentPassword.$touch())),
              "data-test": "current-password"
            }, null, 544), [
              [
                _vModelText,
                currentPassword.value,
                void 0,
                { trim: true }
              ]
            ]),
            _hoisted_8
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _hoisted_12,
            _createVNode(_unref(Tooltip), {
              "data-html": "true",
              target: "#password-icon",
              text: "\r\n            <ul>\r\n              <li>Must be a minimum of 8 characters in length</li>\r\n              <li>Must include at least one number, one uppercase and one lowercase letter</li>\r\n              <li>No spaces at the beginning or end</li>\r\n            </ul>\r\n            "
            })
          ]),
          (_unref(v$).newPassword.required.$invalid && submitStatus.value === 'Error')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, " You must enter a new password "))
            : _createCommentVNode("", true),
          (
              !_unref(v$).newPassword.required.$invalid &&
              _unref(v$).newPassword.minLength.$invalid &&
              submitStatus.value === 'Error'
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Minimum 8 characters long. "))
            : _createCommentVNode("", true),
          (
              !_unref(v$).newPassword.required.$invalid &&
              _unref(v$).newPassword.isPasswordValid.$invalid &&
              submitStatus.value === 'Error'
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Must include a number, an upper and a lower case letter. "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              id: "new-password",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newPassword).value = $event)),
              class: "password-input",
              name: "new password",
              type: "password",
              onBlur: _cache[3] || (_cache[3] = ($event: any) => (_unref(v$).newPassword.$touch())),
              "data-test": "new-password",
              "aria-label": "new password"
            }, null, 544), [
              [
                _vModelText,
                newPassword.value,
                void 0,
                { trim: true }
              ]
            ]),
            _hoisted_17
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          (_unref(v$).confirmPassword.required.$invalid && submitStatus.value === 'Error')
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, " You must confirm your new password "))
            : _createCommentVNode("", true),
          (
              !_unref(v$).confirmPassword.required.$invalid &&
              _unref(v$).confirmPassword.sameAsPassword.$invalid &&
              submitStatus.value === 'Error'
            )
            ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Those passwords didn't match. Try again."))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              id: "confirm password",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((confirmPassword).value = $event)),
              class: "password-input",
              name: "confirm password",
              type: "password",
              onBlur: _cache[5] || (_cache[5] = ($event: any) => (_unref(v$).confirmPassword.$touch())),
              "data-test": "confirmed-password"
            }, null, 544), [
              [_vModelText, confirmPassword.value]
            ]),
            _hoisted_23
          ])
        ]),
        (errorData.value.serverErrorOccured)
          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Something went wrong, please try again later."))
          : _createCommentVNode("", true),
        (errorData.value.otherErrorData)
          ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(errorData.value.otherErrorData), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("button", {
            class: "btn btn-default",
            onClick: toggleChangePassword,
            "data-test": "cancel-password",
            type: "button"
          }, " Cancel "),
          _createElementVNode("button", {
            class: _normalizeClass([canSubmit.value ? 'btn-primary' : 'btn-disabled', "btn"]),
            href: "javascript:void(0)",
            type: "submit",
            "data-test": "submit-new-password"
          }, " Change password ", 2)
        ])
      ], 32)
    ])
  ]))
}
}

})